import { FC } from 'react';
import { MenuItem, Divider, Box, Typography } from '@mui/material';
import MenuPopover from '@components/MenuPopover';
import { styles } from './styles';
import { initial, last } from 'lodash';
import SvgIconStyle from '~/components/SvgIconStyle';
import { DropdownViewOption } from './types';

type Props = {
  handleClose: (event: React.MouseEvent<HTMLElement>) => void;
  viewOptions: DropdownViewOption[];
  anchorEl: HTMLElement | null;
};

const UserDropdown: FC<Props> = ({ handleClose, viewOptions, anchorEl }) => (
  <>
    <MenuPopover
      open={true}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      sx={styles.dropdown}
    >
      {initial(viewOptions).map((viewOption) => (
        <Box display="flex" alignItems="center" key={viewOption.value}>
          <SvgIconStyle src={viewOption.icon} sx={styles.dropdownIcon} />
          <MenuItem value={viewOption.value} onClick={viewOption.onPress} sx={styles.menuItem}>
            <Typography variant="body2">{viewOption.label}</Typography>
          </MenuItem>
        </Box>
      ))}
      <Divider sx={styles.divider} />
      <MenuItem
        value={last(viewOptions)?.value}
        onClick={last(viewOptions)?.onPress}
        sx={styles.menuItem}
      >
        <Typography variant="body2">{last(viewOptions)?.label}</Typography>
      </MenuItem>
    </MenuPopover>
  </>
);

export default UserDropdown;
